import { render, staticRenderFns } from "./researchCenter.vue?vue&type=template&id=39d00ce0&"
import script from "./researchCenter.vue?vue&type=script&lang=js&"
export * from "./researchCenter.vue?vue&type=script&lang=js&"
import style0 from "./researchCenter.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports